export const CHECK_BOX = 'checkBox';
export const COUNTER = 'counter';
export const ENTRY_COUNT = 'entryCount';
export const EXPAND = 'expand';
export const FEE = 'fee';
export const PAYOUT = 'payout';
export const POINTS = 'points';
export const POSITION = 'position';
export const PRIZE = 'prize';
export const WINNINGS = 'winnings';
export const WON = 'won';
